
import { ComercialGeralConfig } from "@/interfaces/Comercial";
import Vue from "vue";
import Component from "vue-class-component";
import { event } from "vue-gtag";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ProdutoImagesCarousel from "./ProdutoImagesCarousel.vue";
import ProdutoInfoDialog from "./ProdutoInfoDialog.vue";
import ProdutoQtdeContainer from "./ProdutoQtdeContainer.vue";

const Produtos = namespace("Produto");
const AppConfigStore = namespace("AppConfig");

@Component({
  name: "ProdutoDetailsDialog",
  components: {
    ProdutoInfoDialog,
    ProdutoImagesCarousel,
    ProdutoQtdeContainer,
  },
})
export default class ProdutoDetailsDialog extends Vue {
  @AppConfigStore.Getter
  getConfigComercialGeral!: ComercialGeralConfig;

  private dlgVisible = false;

  private fullDetails = false;

  private localProduto = {} as any;

  get mainDivHeight() {
    if (this.$vuetify.breakpoint.smAndDown) {
      return "fullscreen-dialog";
    }
    return "";
  }

  formatObsInterna() {
    return this.localProduto?.obsInterna?.length > 200 && !this.fullDetails
      ? this.localProduto?.obsInterna?.substring(0, 200) + "..."
      : this.localProduto?.obsInterna;
  }

  show(produto: any) {
    this.localProduto = produto;
    this.dlgVisible = true;

    event("view_item", {
      items: [
        {
          id: produto.id,
          name: produto.nome,
          category: produto.categoria,
          price: produto.preco,
        },
      ],
    });
  }

  onFecharClick() {
    this.dlgVisible = false;
  }

  @Watch("dlgVisible")
  onDialogClosed(value: any, oldValue: any) {
    if (value === false) {
      this.$emit("dialogClosed", this.localProduto);
    }
  }

  showPoliticaDesconto() {
    const dlg = this.$refs.prodInfoDlg as ProdutoInfoDialog;
    dlg.show(this.localProduto, this.localProduto?.descQtdeMin);
  }
}
